<div class="date-dropdown" [class.error]="errorStateMatcher().isErrorState(control(), null)">
  <dojo-button [fill]="'outline'" [size]="size()" [dojoDatepickerToggle]="datePicker" class="date-button">
    <dojo-icon icon="calendar" [size]="14" class="mr-2" />
    <span class="text-primary font-medium">
      {{ control().value ? (control().value! | formatDate: dateFormat()) : placeholder() }}
    </span>
    <dojo-icon icon="angle-down" [size]="14" class="ml-1.5" />
  </dojo-button>

  <mat-form-field class="hidden-datepicker-field">
    <input
      matInput
      [formControl]="control()"
      [matDatepicker]="datePicker"
      [errorStateMatcher]="errorStateMatcher()"
      [min]="min()"
      [max]="max()"
    />
    <mat-datepicker #datePicker></mat-datepicker>
  </mat-form-field>
</div>
